export default __webpack_public_path__ + "static/media/editor-1.393f8251.jpg";